export const AdminRole = {
  ADMIN: "Admin",
  CRM_MANAGER: "CRMManager",
  ACCOUNTING: "Accounting",
  USER: "User",
};
